import { useTranslations } from 'next-intl';
import { Icon } from '@/components/entities/Sprite';
import BottomSheetModal from '@/components/shared/BottomSheetModal';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const BalanceInfoModal = ({ open, onOpenChange }: Props) => {
  const t = useTranslations('header.balance-card');
  return (
    <BottomSheetModal open={open} onOpenChange={onOpenChange} contentClassName="pb-2">
      <div className="bg-main-800/60 rounded-2xl">
        <p
          className="text-base font-normal leading-6 flex flex-col gap-6"
        >
          <span className="block">
            {t.rich('sweep-coin-info-description', { br: () => <br /> })}
          </span>
          <span className="block">
            {t.rich('sweep-coin-info-description-2', {
              icon: () => <Icon name="sweep-coin" className="inline size-5" />,
            })}
          </span>
        </p>
      </div>
    </BottomSheetModal>
  );
};
export default BalanceInfoModal;
